exports.createComponent = createComponent;

exports.install = install;

function createComponent(name){
    return function(obj){
        obj.name = 'YD-' + name;
        obj.install = install;
        return obj;
    };
}
function install(Vue){
    Vue.component(this.name,this);
}